import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'
import _imports_1 from '../assets/logistics.svg'
import _imports_2 from '@/assets/amico.svg'


const _withScopeId = n => (_pushScopeId("data-v-7067eab6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-login flex items-center w-full justify-center" }
const _hoisted_2 = { class: "container w-full flex justify-center align-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-3/4 mb-8 lg:hidden",
  alt: "Uma logo com a palavra DPC escrita em verde",
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-3xl text-center font-bold border-b-4 pb-2 border-green-500 font-sans" }, " Fazer Login "),
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold font-sans text-left mr-4 ml-4 pt-8" }, " Olá, bem vindo(a) a DPC, é um prazer ter você aqui ")
], -1))
const _hoisted_5 = { class: "w-9/12 flex flex-col justify-center items-center" }
const _hoisted_6 = { class: "grid grid-cols-1 space-y-2 mb-4 w-full" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm text-left font-bold text-gray-500 tracking-wide" }, " Usuário ", -1))
const _hoisted_8 = { class: "grid grid-cols-1 space-y-2 w-full" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm text-left font-bold text-gray-500 tracking-wide" }, "Senha", -1))
const _hoisted_10 = {
  key: 0,
  class: "mb-8 mt-4"
}
const _hoisted_11 = { class: "flex justify-center" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Entrar ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-5/12 hidden sm:hidden lg:flex flex-col items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-1/3 mb-4",
    alt: "Uma logo com a palavra DPC escrita em verde",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-3/4",
    alt: "Imagem de homem com empilhadeira da cor verde e mulher uma mulher em \n          pé verificando algumas caixas do lado da empilhadeira",
    src: _imports_1
  })
], -1))
const _hoisted_14 = { class: "flex flex-col h-full items-center justify-between" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-1/2",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_16 = {
  key: 0,
  class: "font-bold text-lg"
}
const _hoisted_17 = {
  key: 1,
  class: "text-red-500 text-lg font-bold text-center pl-1 pr-1 pb-1"
}
const _hoisted_18 = {
  key: 2,
  class: "text-xs mt-1.5"
}
const _hoisted_19 = {
  key: 3,
  class: "text-xs mt-1.5"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Foi enviado um código de verificação para ")
const _hoisted_21 = { class: "text-dpc" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Verificar ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_recaptcha = _resolveComponent("vue-recaptcha")!
  const _component_Spin = _resolveComponent("Spin")!
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_Code = _resolveComponent("Code")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ChangePassword = _resolveComponent("ChangePassword")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
        class: "login flex flex-col justify-between items-center w-full md:w-5/12"
      }, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              autocomplete: "on",
              id: "user-text-field",
              class: "text-base p-2 border border-gray-300 rounded-lg focus:outline-none focus:border-green-500",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
              type: "text",
              placeholder: "Digite seu usuário"
            }, null, 512), [
              [
                _vModelText,
                _ctx.username,
                void 0,
                { lazy: true }
              ]
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["flex text-xs mt-1 select-none font-bold self-start", _ctx.usernameError ? 'text-red-600' : 'text-transparent'])
            }, _toDisplayString(_ctx.usernameErrorMessage || "(►__◄)"), 3)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              autocomplete: "on",
              id: "password-text-field",
              class: "text-base p-2 border border-gray-300 rounded-lg focus:outline-none focus:border-green-500",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              type: "password",
              placeholder: "Digite sua senha"
            }, null, 512), [
              [_vModelText, _ctx.password]
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["flex select-none text-xs mt-1 font-bold self-start", _ctx.passwordError ? 'text-red-600' : 'text-transparent'])
            }, _toDisplayString(_ctx.passwordErrorMessage || "(►__◄)"), 3)
          ]),
          (_ctx.showCaptcha)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_vue_recaptcha, {
                  onVerify: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onVerifyReCaptcha($event, 2))),
                  onExpired: _cache[3] || (_cache[3] = ($event: any) => (_ctx.captchaSucess = false)),
                  size: "normal",
                  loadRecaptchaScript: true,
                  sitekey: _ctx.recaptchaKey,
                  ref: "recaptcha"
                }, null, 8, ["sitekey"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
            class: "pb-2 pt-2 pr-16 pl-16 bg-dpc hover:bg-green-700 text-white flex items-center rounded"
          }, [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_Spin, { key: 0 }))
              : (_openBlock(), _createBlock(_component_vue_feather, {
                  key: 1,
                  "stroke-width": "3",
                  size: "15",
                  class: "mr-2",
                  type: "lock"
                })),
            _hoisted_12
          ])
        ])
      ], 32),
      _hoisted_13,
      (_ctx.unknownDevice.active)
        ? (_openBlock(), _createBlock(_component_Modal, {
            key: 0,
            width: _ctx.modal.width,
            height: _ctx.modal.height,
            onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.unknownDevice.active = !_ctx.unknownDevice.active))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", null, [
                  (!_ctx.codeInvalid.error)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.unknownDevice.error), 1))
                    : _createCommentVNode("", true),
                  (_ctx.codeInvalid.error)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.codeInvalid.message), 1))
                    : _createCommentVNode("", true),
                  (_ctx.codeInvalid.error)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_18, " Tente fazer login novamente "))
                    : _createCommentVNode("", true),
                  (!_ctx.codeInvalid.error)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("strong", _hoisted_21, _toDisplayString(_ctx.unknownDevice.hiddenEmail), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_Code, {
                    length: 7,
                    clear: _ctx.clearInput,
                    onValue: _cache[6] || (_cache[6] = ($event: any) => (_ctx.verifyCode($event)))
                  }, null, 8, ["clear"])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.checkVerifyCode())),
                    class: "pb-2 pt-2 pr-16 pl-16 bg-dpc hover:bg-green-700 text-white flex items-center rounded"
                  }, [
                    (_ctx.isLoading)
                      ? (_openBlock(), _createBlock(_component_Spin, { key: 0 }))
                      : (_openBlock(), _createBlock(_component_vue_feather, {
                          key: 1,
                          "stroke-width": "3",
                          size: "15",
                          class: "mr-2",
                          type: "shield"
                        })),
                    _hoisted_22
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["width", "height"]))
        : _createCommentVNode("", true),
      (_ctx.modalChangePassword.active)
        ? (_openBlock(), _createBlock(_component_ChangePassword, {
            key: 1,
            onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.modalChangePassword.active = false)),
            deviceFingerPrint: _ctx.modalChangePassword.deviceFingerPrint,
            idusuario: _ctx.modalChangePassword.idusuario,
            onSucess: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changePasswordSucess($event))),
            isExpired: _ctx.passwordIsExpired
          }, null, 8, ["deviceFingerPrint", "idusuario", "isExpired"]))
        : _createCommentVNode("", true)
    ])
  ]))
}